import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { getMerchandiseCount } from '@theme/ffs-cart';

/**
 * Header actions component that manages cart notifications.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} liveRegion - The live region for cart announcements.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {
  requiredRefs = ['liveRegion'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  /**
   * Handles cart update events and announces the new count to screen readers.
   * @param {CustomEvent<{ resource?: { item_count?: number; items?: Array<{ product_id?: string | number; quantity?: number }> } }>} event
   */
  #onCartUpdate = (event) => {
    const cart = event.detail.resource;
    if (!cart || (!Array.isArray(cart.items) && typeof cart.item_count !== 'number')) return;

    const cartCount = getMerchandiseCount(cart);

    this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
  };
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}
